module.exports = __webpack_public_path__ + "static/media/realtimetext-regular.592806dd.woff";